import axios from 'axios';
import apiClient from '../ApiClient';
import { redirectToLoginPage } from '../../../helper';

const GraphService = {
  getGraph: async (params, instance) => {
    try {
      return (await apiClient.post('/fecthchartData', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null;
    }
  },


  materialID: async (params, instance) => {
    try {
      return (await apiClient.post('/getSKUMaterialID', params)).data;
    } catch (error) {
      console.error('Error updating last view:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  skuSTOP: async (params, instance) => {
    try {
      return (await apiClient.post('/skuSTOParameter', params)).data;
    } catch (error) {
      console.error('Error updating last view:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  getScenariosNps: async (parm) => {
    try {
      return (await apiClient.post('/getScenarios', parm)).data;
    } catch (error) {
      console.error('Error fetching getScenarios:', error);
      return null;
    }
  },

  getMapedDC: async (params, instance) => {
    try {
      return (await apiClient.post('/getMapedDC', params)).data;
    } catch (error) {
      console.error('Error Fetching data:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  getMapedDataForFGS: async (params, instance) => {
    try {
      return (await apiClient.post('/getMapedDataForFGS', params)).data;
    } catch (error) {
      console.error('Error Fetching data:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  getScenariosRR: async (params, instance) => {
    try {
      return (await apiClient.post('/getScenarios', params)).data;
    } catch (error) {
      console.error('Error Fetching data:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  getActiveScenarios: async (params, instance) => {
    try {
      return (await apiClient.get('/getActiveScenarios', params)).data;
    } catch (error) {
      console.error('Error Fetching data:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  getActiveEventCounts: async (params, instance) => {
    try {
      return (await apiClient.get('/getActiveEventCounts', params)).data;
    } catch (error) {
      console.error('Error Fetching data:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },

  getExcelData: async (params, instance) => {
    try {
      return (await apiClient.post('/getExcelData', params)).data;
    } catch (error) {
      console.error('Error Fetching data:', error);
      if (error.response && error.response.status === 401) {
        redirectToLoginPage(instance);
      }
      return null; // Graceful fallback
    }
  },
};

export default GraphService;
